module.exports = __webpack_public_path__ + "img/executor.8b37ba53.svg";